// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-dropdown-menu-item a {
    text-decoration: none;
    color: inherit;
}

.ant-dropdown-menu-item-selected {
    background-color: var(--color-surface-brand-strong) !important;
    color: var(--color-text-on-brand) !important;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,8DAA8D;IAC9D,4CAA4C;AAChD","sourcesContent":[":global(.ant-dropdown-menu-item a) {\n    text-decoration: none;\n    color: inherit;\n}\n\n:global(.ant-dropdown-menu-item-selected) {\n    background-color: var(--color-surface-brand-strong) !important;\n    color: var(--color-text-on-brand) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
